import PageHeaderMeta from '@liveauctioneers/caterwaul-components/lib/PageHeaderMeta/PageHeaderMeta';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import * as React from 'react';

import useAddNotificationCountToTitle from '@/hooks/useAddNotificationCountToTitle';
import { useAppSelector } from '@/redux/hooks';
import { getBaseUrl } from '@/redux/modules/config';

const PasswordResetPageHeaderMeta = () => {
    const { formatMessage } = useIntl();
    const baseUrl = useAppSelector((state) => getBaseUrl(state));
    const title = useAddNotificationCountToTitle(formatMessage({ id: 'passwordReset.title' }));
    const description = formatMessage({ id: 'passwordReset.description' });
    const canonical = `${baseUrl}/password_reset`;

    return (
        <PageHeaderMeta
            canonical={canonical}
            description={description}
            title={title}
        />
    );
};

export default PasswordResetPageHeaderMeta;
